import React from 'react';
import PropTypes from 'prop-types';
import './Loader.css';
import loadingImage from '../../assets/images/loading-image.gif';

export const Loader = ({ overlay, isActive, message }) => (
  <div
    className={`loading ${overlay ? 'overlay' : ''} ${
      isActive ? 'active' : ''
    }`}
  >
    <img src={loadingImage} className="spinner" alt="loading" />
    <span className="d-none">{message}</span>
  </div>
);

Loader.propTypes = {
  overlay: PropTypes.bool,
  isActive: PropTypes.bool,
  message: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js